import axios, { AxiosResponse } from 'axios';
import { IGetFileContentPayload } from '../getFileUrl/getFileUrl.service';

export default function getDocumentContentService({ signal, payload }: IGetFileContentPayload): Promise<AxiosResponse<any>> {
  const url = '/api/getDocument';
  return axios.get(url, {
    signal,
    params: {
      filepath: payload,
    },
    responseType: 'blob',
  });
}
